<template>
  <section id="main-content" class="clearfix">
    <div class="btn btn-primary" @click="goToZone">
      Back
    </div>
    <blockquote>Add Locations to <strong>{{ name }}</strong> zone using both/either subdivision and country</blockquote>
    <div class="form-group">
      <label for="vz-sub" class="form-label">Subdivision</label>
      <input type="text" class="form-control" id="vz-sub" v-model="searchCriteria.subdivision"/>
    </div>
    <div class="form-group">
      <label for="location-country" class="form-label">Country</label>
      <select class="form-control" id="location-country" v-model="searchCriteria.country">
        <option value=""></option>
        <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
      </select>
    </div>
    <div class="btn btn-primary sq" @click="search">
      Search
    </div>
    <div class="white-bg shadow">
      <ul class="list-group">
        <li class="list-group-item clearfix" v-for="(zone, i) in zones">
          {{ displayFn(zone.location) }}
          <div class="pull-right">
            <div class="btn btn-danger" @click="remove(zone, i)">
              <i class="fa fa-times"></i>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
import api from '../../../../api/endpoints'
import event from '../../../../event'
import AdminEntityMixin from '../../mixins/AdminEntityMixin'
import HelperMixin from '../../mixins/Helpers'
import { createRouteIdHash } from '../../../helpers/RouteHash'
export default {
  name: 'VZBuilder',
  mixins: [AdminEntityMixin, HelperMixin],
  data () {
    return {
      searchCriteria: {
        subdivision: null,
        country: null
      },
      results: [],
      zones: [],
      boxes: [],
      entity: {
        id: null,
        externalId: null,
        vendor: null,
        location: {
          id: null,
          name: null,
          category: 'VENDOR_ZONE',
          functionMaritime: 0,
          functionRail: 0,
          functionRoad: 0,
          functionAir: 0
        },
        deleted: null
      },
      entityName: 'vendor-zone'
    }
  },
  computed: {
    request () {
      const obj = {}
      for (let prop in this.searchCriteria) {
        if (this.searchCriteria[prop]) {
          obj[prop] = this.searchCriteria[prop]
        }
      }
      return obj
    },
    valid () {
      return this.searchCriteria.country || this.searchCriteria.subdivision
    },
    name () {
      return this.entity.location && this.entity.location.name ? this.entity.location.name : 'this'
    },
    locations () {
      return this.results.map(({id}) => id)
    },
    updateBody () {
      return {
        locations: this.locations,
        vendorZone: this.entity
      }
    }
  },
  methods: {
    goToZone () {
      this.$router.push({ name: 'Admin - Edit/View Vendor Zone', params: { id: createRouteIdHash(this.entity.id) } })
    },
    search () {
      if (this.valid) {
        this.$http.get(api.GET_ENTITIES('location'), {
          params: this.request,
          headers: { 'X-Lazy-Fetch': 'true' }
        }).then(({data}) => {
          this.results = data
          this.update()
        }).catch(console.log)
      } else {
        event.$emit('toast', { type: 'warning', message: 'Ensure you provide a search criteria' })
      }
    },
    update () {
      if (this.locations.length > 0) {
        this.$http.post(api.UPDATE_VZ, this.updateBody)
          .then(({data}) => {
            this.zones = data.filter(item => item !== null)
            event.$emit('toast', { type: 'success', message: `${this.zones.length} locations added` })
          })
          .catch(console.log)
      } else {
        event.$emit('toast', { type: 'warning', message: `No Locations match this search` })
      }
    },
    displayFn (location) {
      let str = ''
      if (location.name) {
        str += location.name
      }
      if (location.subdivision) {
        str += str.length > 0 ? `, ${location.subdivision}` : location.subdivision
      }
      return str
    },
    remove ({ id }, i) {
      this.deleteRelatedEntity('vendor-zone-to-location', id)
      .then(({data}) => {
        event.$emit('toast', { type: 'success', message: 'Vendor Zone Location deleted' })
        this.zones.splice(i, 1)
      })
      .catch(err => {
        event.$emit('toast', { type: 'error', message: 'Unable to delete Vendor Zone Location; please try again or contact support' })
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
blockquote {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/VendorZone/VZBuilder.vue